import { render } from "./FileUploader.vue?vue&type=template&id=dd086f72"
import script from "./FileUploader.vue?vue&type=script&lang=ts"
export * from "./FileUploader.vue?vue&type=script&lang=ts"
script.render = render

export default script